import { ValidatedToolResponse } from '@seen/core/models/validatedToolResponse'
import { Button } from '@seen/ui'
import { IconLock, IconLockOpen } from '@tabler/icons-react'
import { type JSX, useState } from 'react'
import { useParams } from 'react-router'
import { ValidatedToolForm } from '#src/components/validated-tool-form/ValidatedToolForm.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function ValidatedToolResponsePage(): JSX.Element {
  const { questionnaireResponseId } = useParams()
  const { data: response, isLoading } = useRead(
    ValidatedToolResponse,
    questionnaireResponseId
  )
  const name = response?.name?.toLowerCase()

  const [unlocked, setUnlocked] = useState(false)

  return (
    <>
      <ValidatedToolForm
        name={name}
        response={response}
        isLoading={isLoading}
        disabled={!unlocked}
        className="pb-16"
      />
      {name === 'enn' && (
        <Button
          variant="outline"
          onClick={() => setUnlocked((locked) => !locked)}
          className="absolute right-4 bottom-4 z-10 bg-background"
          size="icon"
        >
          {unlocked ? (
            <IconLockOpen className="size-4" />
          ) : (
            <IconLock className="size-4" />
          )}
        </Button>
      )}
    </>
  )
}
